import type { Router } from 'vue-router'

let activeRouter: Router | null = null

export function configureNavigation(router: Router) {
  activeRouter = router
}

export function normalizeRouteUrl(url: string) {
  if (!url) {
    return '/'
  }
  const [path, query = ''] = url.split('?')
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return query ? `${normalizedPath}?${query}` : normalizedPath
}

export async function navigateTo(url: string) {
  await activeRouter?.push(normalizeRouteUrl(url))
}

export async function redirectTo(url: string) {
  await activeRouter?.replace(normalizeRouteUrl(url))
}

export async function reLaunch(url: string) {
  await activeRouter?.replace(normalizeRouteUrl(url))
}

export async function switchTab(url: string) {
  await activeRouter?.replace(normalizeRouteUrl(url))
}

export function navigateBack() {
  activeRouter?.back()
}
